export enum OgranPasswordEnum {
  OFF,
  ON,
}
